module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "apologia"
    }
  }, [_c('h1', [_vm._v("APOLOGIA")]), _vm._v(" "), _c('p', [_vm._v("For the historical background of this narrative, I consulted, among others, the following sources: Las aguas de Madrid, en paz y en guerra, de la segunda republica by José María Sanz García, Los Viajes de Agua de Madrid by María Isabel Gea Ortigas, Las galerías de servicios en Madrid by A. Sánchez Trasancos, The Spanish Civil War by Hugh Thomas, and the collective work, La Guerra Civil Española, Vols V, XV, XVIII and XIX.")]), _vm._v(" "), _c('p', [_vm._v("The story about Cardinal Cisneros murdering a mountain cat (in the chapter The Pitfalls of Finance) is featured in Los nombres de las calles de Madrid by María Isabel Gea Ortigas.")]), _vm._v(" "), _c('p', [_vm._v("Some Spanish terms (explained in the Glossary) are preceded by reversed (¡, ¿) exclamation and question marks, as customary in that language.")]), _vm._v(" "), _c('p', [_vm._v("Atentamente,")]), _vm._v(" "), _c('p', [_vm._v("J.C.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c1d7b040","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/ch005.vue
// module id = 75
// module chunks = 0